import {messageInfo} from "./MessageInfo";
import axios from "axios";

//=======================  请求拦截器  ===========================
axios.interceptors.request.use(
  config => {
    if (window.sessionStorage.getItem('token')) {
      config.headers['Authorization'] = window.sessionStorage.getItem('token');
    }
    return config;
  }, error => {
    console.log("Something Wrong With The Request ==>  ", error);
  }
)

//=======================  响应拦截器  ===========================
axios.interceptors.response.use(
  res => {
    if (res.status && res.status === 200) {
      //  业务逻辑
      if (res.data.code === 50000 || res.data.code === 401 || res.data.code === 40003) {
        messageInfo({type: 'error', message: res.data.message});
        res.status = false;
        return res.data;
      } else if (res.data.code === 52002) {
        // 若没登陆 需要特殊处理
        // 之前并没有对登录进行特殊处理
        if (window.location.pathname !== '/login') {
          // 如果不是登录界面就跳出此消息
          messageInfo({
            type: 'error',
            message: "尚未登陆，请登陆！<a href='/login'>去登陆</a>",
            duration: 0,
            dangerouslyUseHTMLString: true,
            showClose: true
          });
        }
        return res.data;
      } else {
        return res.data;
      }
    }
    messageInfo({type: "error", message: "连接错误！"});
  }, error => {
    if (error.response !== undefined) {
      if (error.response.code === 404 || error.response.code === 504) {
        messageInfo({type: "error", message: "服务器被怪兽吃了  ┴┴︵╰（‵□′）╯︵┴┴ "});
      } else if (error.response.code === 403) {
        messageInfo({type: "error", message: "权限不足，请联系管理员！"});
      } else if (error.response.code === 401) {
        messageInfo({type: "error", message: "尚未登陆，请登陆！"});
        this.$router.replace('/login').then(r => console.log(r));
      } else {
        if (error.response.message) {
          messageInfo({type: "error", message: error.response.message});
        } else {
          messageInfo({type: "error", message: "网络异常！"});
        }
      }
      // 抛出异常
      throw error;
    }else{
      return error;
    }
  }
);

//=======================  请求封装  ===========================
let baseUrl = "/v2/api";
// let baseUrl = "muming-system:9090"

// Get
export const getRequest = (url, params) => {
  return axios({

    method: 'get',
    url: `${baseUrl}${url}`,
    params: params
  })
}

// 使用 超时设置 的 Get
export const getRequestWithTimeout = (url, params, timeout) => {
  return axios({

    method: 'get',
    url: `${baseUrl}${url}`,
    params: params,
    timeout: timeout
  })
}

// Post
export const dataPostRequest = (url, data) => {
  return axios({
    method: 'post',
    url: `${baseUrl}${url}`,
    data: data
  })
}

//Post
export const paramsPostRequest = (url, params) => {
  return axios({

    method: 'post',
    url: `${baseUrl}${url}`,
    params: params
  })
};

// Put
export const paramsPutRequest = (url, params) => {
  return axios({

    method: 'put',
    url: `${baseUrl}${url}`,
    params: params
  })
}

// Put
export const dataPutRequest = (url, data) => {
  return axios({

    method: 'put',
    url: `${baseUrl}${url}`,
    data: data
  });
};

// delete
export const deleteRequest = (url, params) => {
  return axios({

    method: 'delete',
    url: `${baseUrl}${url}`,
    params: params
  })
};

export const getBaseUrl = () => {
  return `${baseUrl}`;
}



// WEBPACK FOOTER //
// ./src/utils/request.js